"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_AREA_ROOT = void 0;
const TOP_AREA_ROOT = exports.TOP_AREA_ROOT = 'root';